import React from 'react'
import { Link } from 'gatsby'
import { useStaticQuery, graphql } from 'gatsby'

import heartSvg from '../../content/assets/heart.svg'

const Layout = props => {
  const { children, optionalFloatingBar } = props

  const [toggleNav, setToggleNav] = React.useState(false)
  const data = useStaticQuery(
    graphql`
      query LayoutQuery {
        site {
          siteMetadata {
            title
            siteUrl
            social {
              twitter
              facebook
            }
          }
        }
      }
    `
  )
  const title = data.site.siteMetadata.title
  const siteUrl = data.site.siteMetadata.siteUrl

  const twitterLink = data.site.siteMetadata.social.twitter
  const facebookLink = data.site.siteMetadata.social.facebook

  return (
    <div className={`site-wrapper ${toggleNav ? `site-head-open` : ``}`}>
      <header className="site-head">
        <div className="site-head-container">
          <button
            className="nav-burger"
            onClick={() => setToggleNav(!toggleNav)}
          >
            <div
              className="hamburger hamburger--collapse"
              aria-label="Menu"
              role="button"
              aria-controls="navigation"
            >
              <div className="hamburger-box">
                <div className="hamburger-inner" />
              </div>
            </div>
          </button>
          <nav id="swup" className="site-head-left">
            <ul className="nav" role="menu">
              <li className="nav-home nav-current" role="menuitem">
                <Link to={`/`}>Home</Link>
              </li>
              {/*
              <li className="nav-about" role="menuitem">
                <Link to={`/about`}>About</Link>
              </li>
              <li className="nav-elements" role="menuitem">
                <Link to={`/elements`}>Elements</Link>
              </li>
              */}
            </ul>
          </nav>
          <div className="site-head-center">
            <Link className="site-head-logo" to={`/`}>
              {title}
            </Link>
          </div>
          <div className="site-head-right">
            <div className="friendly-links">
              {facebookLink ? (
                <a
                  href={data.site.siteMetadata.social.facebook}
                  title="Facebook"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facebook
                </a>
              ) : null}
              {twitterLink ? (
                <a
                  href={data.site.siteMetadata.social.twitter}
                  title="Twitter"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Twitter
                </a>
              ) : null}
              <a
                href={`https://feedly.com/i/subscription/feed/${siteUrl}/rss.xml`}
                title="RSS"
                target="_blank"
                rel="noopener noreferrer"
              >
                RSS
              </a>
            </div>
          </div>
        </div>
      </header>
      <main id="site-main" className="site-main">
        {optionalFloatingBar}
        <div id="swup" className="transition-fade">
          {children}
        </div>
      </main>
      <footer className="site-foot">
        &copy; {new Date().getFullYear()} <Link to={`/`}>{title}</Link>
        <br />
        Presented to you with&nbsp;
        <a
          href="https://gatsbyjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Gatsby
        </a>
        &nbsp;&amp;&nbsp;
        <br className="show-xsmall" />
        all the&nbsp;
        <img
          src={heartSvg}
          style={{
            height: '24px',
            width: '24px',
            zoom: '0.8',
            marginTop: '-1rem',
          }}
          alt="heart"
        />
        &nbsp; in the world
      </footer>
    </div>
  )
}

export default Layout
